import { render, staticRenderFns } from "./Mcanceled.vue?vue&type=template&id=b2a2fce8&scoped=true&"
import script from "./Mcanceled.vue?vue&type=script&lang=js&"
export * from "./Mcanceled.vue?vue&type=script&lang=js&"
import style0 from "./Mcanceled.vue?vue&type=style&index=0&id=b2a2fce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a2fce8",
  null
  
)

export default component.exports